import {createFileRoute} from '@tanstack/react-router';
import {DepositApplicationCallbackPage} from 'features/deposit/onboarding/pages/DepositApplicationCallbackPage';

export const Route = createFileRoute(
  '/_protected/deposit-onboarding/$applicationId/callback',
)({
  component: DepositApplicationCallbackPage,
  validateSearch: (search) => {
    return {
      productCode: search.productCode as string | undefined,
    };
  },
});
